(() => {
  const bar = document.getElementById('pb-sticky-atc');
  if (!bar) return;
  const button = bar.querySelector('button');
  let observed, observer, pending = false;
  const source = () => document.querySelector('product-info[id^="MainProduct-"]');
  function sync() {
    pending = false;
    const main = source();
    if (main !== observed) {
      observer?.disconnect();
      observed = main;
      if (main) {
        observer = new MutationObserver(schedule);
        observer.observe(main, {subtree:true, childList:true, characterData:true, attributes:true,
          attributeFilter:['disabled','aria-disabled','class','hidden','value']});
      }
    }
    const submit = main?.querySelector('product-form button[name="add"]');
    bar.hidden = !submit;
    document.body.classList.toggle('pb-has-sticky-atc', !!submit);
    if (!submit) return;
    button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    button.setAttribute('aria-busy', String(submit.classList.contains('loading')));
    const priceRoot = main.querySelector('[id^="price-"] .price');
    const price = priceRoot?.querySelector(priceRoot.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
    const label = submit.querySelector('span')?.textContent.trim() || bar.dataset.label;
    button.textContent = label + (!button.disabled && price ? ' — ' + price.textContent.trim() : '');
    const error = main.querySelector('.product-form__error-message-wrapper:not([hidden])');
    if (error && error.textContent.trim()) {
      bar.querySelector('[role="status"]').textContent = error.textContent.trim();
    } else bar.querySelector('[role="status"]').textContent = '';
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(sync); }
  }
  button.addEventListener('click', () => {
    const main = source();
    const submit = main?.querySelector('product-form button[name="add"]');
    if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
    // Use the existing form, including quantity, variant and custom properties.
    submit.click();
    schedule();
  });
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  const content = document.getElementById('MainContent');
  if (content) new MutationObserver(schedule).observe(content, {childList:true});
  sync();
})();
